import {
  BlackScholes,
  BlackScholesDetails,
  BlackScholesReport,
  BlackScholesV2,
} from "../types/blackScholes";
import optionsApi from "./optionsApi";

export async function getAllGrantsForBlackScholes(): Promise<BlackScholesDetails> {
  return optionsApi
    .get(`v1/blackScholes/grantDetails`)
    .then((res) => res.data.data);
}

export async function blackScholesDetails(
  data: BlackScholesV2
): Promise<{ [key: string]: BlackScholes }> {
  return optionsApi
    .post(`v1/blackScholes/details`, data)
    .then((res) => res.data.data);
}

export async function addBlackScholesReport(
  data: BlackScholesV2
): Promise<any> {
  return optionsApi
    .post(`v1/blackScholes/add`, data)
    .then((res) => res.data.data);
}

export async function editBlackScholesReport(
  id: string,
  data: BlackScholesV2
): Promise<any> {
  return optionsApi
    .put(`v1/blackScholes/edit/${id}`, data)
    .then((res) => res.data.data);
}

export async function getEditDetails(id?: string): Promise<BlackScholesV2> {
  return optionsApi
    .get(`v1/blackScholes/editDetails?id=${id}`)
    .then((res) => res.data.data);
}

export async function getAllBlackScholes(): Promise<BlackScholesReport[]> {
  return optionsApi.get(`v1/blackScholes/all`).then((res) => res.data.data);
}

export async function downloadValuationAssumptionsTemplate({
  grantIds,
}: {
  grantIds: string[];
}) {
  const res = await optionsApi.post(
    "/v1/blackScholes/valuation-date-template",
    {
      grantIds,
    },
    {
      responseType: "blob",
    }
  );
  return res.data;
}

export async function uploadValuationAssumptionsTemplate(
  file: File,
  grantIds: string[]
): Promise<{
  mapping: { [key: string]: string } | null;
  errors: string[];
}> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("grantIds", JSON.stringify(grantIds));

  const res = await optionsApi.post(
    "/v1/blackScholes/parse-valuation-date-mapping",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return res.data.data;
}

export async function downloadOtherAssumptionsTemplate({
  valuationDates,
}: {
  valuationDates: string[];
}) {
  const res = await optionsApi.post(
    "/v1/blackScholes/other-assumptions-template",
    {
      valuationDates,
    },
    {
      responseType: "blob",
    }
  );
  return res.data;
}

export async function uploadOtherAssumptionsTemplate(
  file: File,
  valuationDates: string[]
) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("valuationDates", JSON.stringify(valuationDates));
  const res = await optionsApi.post(
    "/v1/blackScholes/parse-other-assumptions",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return res.data.data;
}

export async function approveBlackScholesReport(id: string): Promise<any> {
  return optionsApi
    .put(`v1/blackScholes/approve/${id}`)
    .then((res) => res.data.data);
}

export async function deleteBlackScholesReport(id: string): Promise<any> {
  return optionsApi
    .put(`v1/blackScholes/delete/${id}`)
    .then((res) => res.data.data);
}
